import { useCallback, useMemo } from 'react';

import type { UsePromotionPreviewDataProps } from '../types';
import { buildCurrentPromotion, buildOfferData } from '../utils';

/**
 * Custom hook to generate dynamic preview data for promotion offers
 * Constructs the preview data structure from form values in real-time
 */
export const usePromotionPreviewData = ({
    values,
    getOfferUI,
    productsListForPreview,
    badges,
    emblemBadges,
    ribbonBadges,
    transformPriceValue
}: UsePromotionPreviewDataProps) => {

    const stableTransformPriceValue = useCallback(() => {
        return transformPriceValue();
    }, [transformPriceValue]);

    const dynamicOfferData = useMemo(() => {
        // Only create preview if we have the necessary data
        if (!values.offerUiId || !getOfferUI.data) {
            return null;
        }

        const currentPromotion = buildCurrentPromotion({
            values,
            getOfferUI: getOfferUI.data,
            productsListForPreview,
            badges,
            emblemBadges,
            ribbonBadges,
            transformPriceValue: stableTransformPriceValue
        });

        return buildOfferData(currentPromotion);
    }, [
        values,
        getOfferUI.data,
        productsListForPreview,
        badges,
        emblemBadges,
        ribbonBadges,
        stableTransformPriceValue,
    ]);

    return dynamicOfferData;
};
